import axios from 'axios';

/**
 * UP-16 (2026-05-17): version endpoint клиент.
 * Без auth (health endpoint) — отдельный axios instance, без interceptor'ов.
 */
export async function getBackendVersion(): Promise<string> {
  try {
    const baseURL =
      typeof window !== 'undefined' && window.location.hostname !== 'localhost'
        ? '/api/v1'
        : 'http://localhost:3012/api/v1';
    const response = await axios.get<{ service: string; version: string }>(
      `${baseURL}/health/version`,
      { timeout: 3000 },
    );
    return response.data?.version ?? 'unknown';
  } catch {
    return 'unknown';
  }
}
